import groupService from "../../request/service/group-service";
const group = {
    namespaced: true,
   state: {
       groupArray: [],
       groupItem: {width: null, height: null, name: null, json:{data: []}},
       materialUrl: '',
       dialogVisiable: false,
       selectedIndex: 0,
       activeGroupIndex: 0,
    },
    mutations: {
        set_groups(state, templates){
            state.groupArray = templates;
        },
        set_group(state, groupItem){
            state.groupItem = groupItem;
        },
        set_template_material(state, url){
            state.materialUrl = url;
        },
        toggle_dialog(state, trueOrFalse){
            state.dialogVisiable = trueOrFalse;
        },
        next_select(state, index){
            state.selectedIndex = index;
        },
        set_select(state, curIndex){
            state.selectedIndex = curIndex;
        },
        set_new_img(state, imgUrl){
            let dataList = state.groupItem.json.data;
            dataList[state.selectedIndex].url = imgUrl;
            state.groupItem.json.data = dataList;
        },
        set_group_index(state, index){
            state.activeGroupIndex = index;
        }
    },
    actions: {
        queryImgTemplateList ({commit}, projectId) {
            return groupService.getGroupList(projectId).then((data) =>{
                commit('set_groups', data);
                return data;
            });
        }
    }
}
export default group;
